<app-breadcrumbs></app-breadcrumbs>
<h3>Chainwide Circuits</h3>
<div class="map-container" [cfaLoading]="isLoading">
  <div echarts [options]="circuitsOption" class="demo-chart"></div>
</div>

<!-- <div class="cards" [cfaLoading]="isLoading">
<mat-card class="card">
  <mat-card-content class="card-content">
    <h3 class="card-header">{{ fortinetAvailability["avail_pct"] | number : '1.2-2' }} %</h3>
    available in {{ fortinetAvailability["month_name"] }}
  </mat-card-content>
</mat-card>
</div> -->

<div class="cards" [cfaLoading]="isLoading">
  <mat-card class="card">
    <mat-card-content class="card-content">
      <h3 class="card-header">{{ fortinetAvailability["avail_pct"] | number : '1.2-3' }} %</h3>
      available in {{ fortinetAvailability["month_name"] }}
    </mat-card-content>
  </mat-card>
  <mat-card class="card">
    <mat-card-content>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Vendor</th>
            <th scope="col">Count</th>
          </tr>
        </thead>
        <tbody>
          @for (vendor of vendorCountsDict | keyvalue; track vendor) {
            <tr>
              <td>{{vendor.key.slice(0,16)}}</td>
              <td>{{vendor.value}}</td>
            </tr>
          }
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
  <mat-card class="card">
    <mat-card-content>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Count</th>
          </tr>
        </thead>
        <tbody>
          @for (circuitType of typeCountsDict | keyvalue; track circuitType) {
            <tr>
              <td>{{circuitType.key}}</td>
              <td>{{circuitType.value}}</td>
            </tr>
          }
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
  <mat-card class="card">
    <mat-card-content>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Speed</th>
            <th scope="col">Count</th>
            <th scope="col">Total MRC</th>
            <th scope="col">Avg. MRC</th>
          </tr>
        </thead>
        <tbody>
          @for (speed of speedCountsList; track speed) {
            <tr>
              <td>{{speed.speed}}</td>
              <td>{{speed.count}}</td>
              <td>${{speed.mrcTotal | number : '1.2-2'}}</td>
              <td>${{speed.mrcTotal / speed.countKnownMrc | number : '1.2-2'}}</td>
            </tr>
          }
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>